import axios from 'axios';
import {
  ICraftingBlueprint,
  IDailyRewards,
  IGetActiveGame,
  IGetCoin,
  IGetFule,
  IGetHistory,
  IGetInventory,
  IGetOverallTwo,
  IGetPlanetsPlan,
  IGetPlanetsRecipe,
  IPropsMinigame,
  ISetUsername,
} from '@/types/DTO/miniGame';
import { IGeneralPlanet, IGetLrtPrice } from '@/types/lite-game';
import { axiosInstanceStrapi } from '../serviceStrapi';
import { axiosInstanceTwo } from '../serviceTest';
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getInventory: (token?: string) =>
    axiosInstanceTwo.get<IGetInventory>('/api/minigame/get/inventory', {
      headers: { token },
    }),

  getGameFule: (params: IPropsMinigame) =>
    axiosInstanceTwo.get<IGetFule>('/api/minigame/get/game/fule', {
      params,
    }),

  getGameCoin: (params: IPropsMinigame) =>
    axiosInstanceTwo.get<IGetCoin>('/api/minigame/get/game/coin', {
      params,
    }),

  checkExplore: (token?: string) =>
    axiosInstanceTwo.get<any>('/api/minigame/check/explor/live', {
      headers: { token },
    }),

  getGameHistory: (token?: string) =>
    axiosInstanceTwo.get<IGetHistory>('/api/minigame/get/game/history', {
      headers: { token },
    }),
  getRecipe: (params: { recip: string }) => axiosInstanceTwo.get(`/api/minigame/get/recipe/per/id?recip=${params}`),
  getActiveGame: (token?: string) =>
    axiosInstanceTwo.get<IGetActiveGame>('/api/minigame/get/active/game', {
      headers: { token },
    }),
  getRewardStatus: (token?: string) =>
    axiosInstanceTwo.get('/api/minigame/daily/login', {
      headers: { token },
    }),
  getTimeStartMining: (
    params: {
      planet: string;
      rover: string;
      fuel_id: string;
    },
    token?: string,
  ) =>
    axiosInstanceTwo.get('/api/minigame/start/explorer', {
      headers: { token },
      params,
    }),
  getPlanetsPlan: () => axiosInstanceTwo.get<IGetPlanetsPlan>('/api/minigame/get/planets/plan'),


  getPlanetsRecipe: (token?: string) =>
    axiosInstanceTwo.get<IGetPlanetsRecipe>('/api/minigame/get/user/planets/recipe', {
      headers: { token },
    }),
  getDailyReward: () => axiosInstanceTwo.get<IDailyRewards>('/api/minigame/get/daily/data'),
  // getAchievement: () =>
  //   axiosInstanceTwo.get<IAchievements>(
  //     'http://92.204.53.43:1337/achievements',
  //   ),
  getUserData: (token?: string) =>
    axiosInstanceTwo.get('/api/minigame/get/user/data', {
      headers: {
        token,
      },
    }),

  getUserData2DGame: (token?: string) =>
    axiosInstanceTwo.get('/api/2dmining/get/user/data', {
      headers: {
        token,
      },
    }),

  getOverallStats: () => axiosInstanceTwo.get<IGetOverallTwo>('/api/minigame/get/game/overall/data'),

  getMyStats: (token?: string) =>
    axiosInstanceTwo.get('/api/minigame/get/game/user/data', {
      headers: {
        token,
      },
    }),

  getMyStatsTwo: (token?: string) =>
    axiosInstanceTwo.get('/api/minigame/get/web/user/data', {
      headers: {
        token,
      },
    }),
  getAchivement: (token?: string) =>
    axiosInstanceTwo.get('/api/minigame/get/achivement/data', {
      headers: {
        token,
      },
    }),
  getActiveAchivment: (token?: string) =>
    axiosInstanceTwo.get('/api/minigame/get/user/achivement/data', {
      headers: {
        token,
      },
    }),
  getReferralCode: (token?: string) =>
    axiosInstanceTwo.get('/api/set/new/user/get/referral', {
      headers: {
        token,
      },
    }),
  getInventoryUser: (token?: string) =>
    axiosInstanceTwo.get('api/minigame/get/game/elements/inventory', {
      headers: {
        token,
      },
    }),

  craftBlueprint: (params: { recip_id: string }, token?: string) =>
    axiosInstanceTwo.get('/api/minigame/craft/asset', {
      headers: {
        token,
      },
      params,
    }),

  craftingBlueprint: (params: { recipe_id: string }, token?: string) =>
    axiosInstanceTwo.get<ICraftingBlueprint>('/api/minigame/craft/check/materials', {
      headers: {
        token,
      },
      params,
    }),

  collectFeul: (params: { asset_id: string; fuel_id: string }, token?: string) =>
    axiosInstanceTwo.get<any>('/api/minigame/colect/daily/fuel', {
      headers: {
        token,
      },
      params,
    }),

  setNewUsername: (params: ISetUsername, token?: string) =>
    axiosInstanceTwo.get<IGetInventory>('/user/set/username', {
      headers: {
        token,
      },
      params,
    }),

  generalData: () => axiosInstanceTwo.get('/api/minigame/get/general/data'),
  getLrtPrice: () => axios.get<IGetLrtPrice>('https://check-price.landrocker.io/api/v1/get-lrt-price/'),
  generalPlanet: () => axiosInstanceTwo.get<IGeneralPlanet>('/api/lite/game/get/general/data'),

  getExploreFinishStats: (token?: string) =>
    axiosInstanceTwo.get('/api/minigame/explor/finish', {
      headers: {
        token,
      },
    }),

  getPopups: () => axiosInstanceTwo.get('/api/General/popup'),

  getLevelUpReward: (recipeId: number) => axiosInstanceTwo.get(`api/minigame/get/recipe/per/id?recipe=${recipeId}`),
  getTwitterInformation: () => axiosInstanceStrapi.get<any[]>('/data?params=twitter-tasks'),
  getUserTwitterActions: (id) => axiosInstanceTwo.get<any>(`/social/check/user/twitter/action?task_id=${id}`),
  setUserTwitterActions: (id) => axiosInstanceTwo.get<any>(`/social/set/user/twitter/action?task_id=${id}`),
};
